import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow\">\n<path d=\"M3 12H21M21 12L11.8085 2M21 12L11.8085 22\" stroke=\"white\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol